import { render, staticRenderFns } from "./TiptapChip.vue?vue&type=template&id=3b761ab3"
import script from "./TiptapChip.vue?vue&type=script&lang=js"
export * from "./TiptapChip.vue?vue&type=script&lang=js"
import style0 from "./TiptapChip.vue?vue&type=style&index=0&id=3b761ab3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports